module.exports = __webpack_public_path__ + "static/img/Sheep-Animation-page.98555e3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sheep-Animation-page.gif
// module id = utcZ
// module chunks = 1